import React from 'react';
import useSsrUserAgent from 'app/hook/common/useSsrUserAgent';
import classnames from 'classnames/bind';

import styles from './FadeUpModal.module.scss';

const cx = classnames.bind(styles);

const FadeUpModal = ({ id = undefined, children = null, onClose = undefined, classArray = [], dimmed = false, onClickDimmedArea = undefined, usePcLayout = true, modalClass = [] }) => {
	const ua = useSsrUserAgent();
	const handleClose = () => {
		if (onClose) {
			onClose();
		}
	};

	return (
		<div
			id={id}
			className={cx('area', ua().isIE && 'no_animation', classArray, { dimmed })}
			onClick={onClickDimmedArea}
			role="presentation"
		>
			<div
				className={cx('wrap', modalClass)}
				onClick={onClickDimmedArea && ((e) => e.stopPropagation())}
				role="presentation"
			>
				<div className={cx({ pc_layout: usePcLayout && ua().isPc })}>
					{children}
					{onClose && (
						<button
							className={cx('btn', 'ico_close')}
							onClick={handleClose}
						>
							닫기
						</button>
					)}
				</div>
			</div>
		</div>
	);
};

export default FadeUpModal;
